/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Friedrich_Dessauer_Gymnasium_Aschaffenburg5Inputs */

const en__field__enum_schoolname_friedrich_dessauer_gymnasium_aschaffenburg5 = /** @type {(inputs: _Field__Enum_Schoolname_Friedrich_Dessauer_Gymnasium_Aschaffenburg5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aschaffenburg`)
};

const de__field__enum_schoolname_friedrich_dessauer_gymnasium_aschaffenburg5 = /** @type {(inputs: _Field__Enum_Schoolname_Friedrich_Dessauer_Gymnasium_Aschaffenburg5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friedrich-Dessauer-Gymnasium`)
};

/**
* | output |
* | --- |
* | "Aschaffenburg" |
*
* @param {_Field__Enum_Schoolname_Friedrich_Dessauer_Gymnasium_Aschaffenburg5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_friedrich_dessauer_gymnasium_aschaffenburg5 = /** @type {((inputs?: _Field__Enum_Schoolname_Friedrich_Dessauer_Gymnasium_Aschaffenburg5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Friedrich_Dessauer_Gymnasium_Aschaffenburg5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_friedrich_dessauer_gymnasium_aschaffenburg5(inputs)
	return de__field__enum_schoolname_friedrich_dessauer_gymnasium_aschaffenburg5(inputs)
});
export { _field__enum_schoolname_friedrich_dessauer_gymnasium_aschaffenburg5 as "_field__enum_schoolName_Friedrich_Dessauer_Gymnasium_Aschaffenburg" }